const auth = {
	title: "Innlogging",
	sign_in: "Logg inn i Admin Portal",
	login_error: "Feil brukernavn og/eller passord. Vennligst prøv igjen.",
	login: "Logg inn",
	logout: "Logg ut",
	email: "Epost",
	mobile: "Mobil",
	password: "Passord",
	change_password: "Endre passord",
	update_password: "Oppdatere passord",
	current_password: "Nåværende passord",
	update_password_error: "Oppdatering av passord feilet. Vennligst prøv igjen.",
	password_does_not_match_error: "Passord er ulike",
	new_password: "Nytt passord",
	new_password_retype: "Gjenta nytt passord",
	remember: "Husk meg",
	sign_up: "Registrer",
	no_account: "Har du ikke konto?",
	success: "Vellykket",
	error: "Feil",
	login_email: "Logg inn med epost",
	login_mobile: "Login med mobil",
	sms_code: "SMS kode",
	enter_code: "Bruk kode",
	enter_code_sms: "Bekreftelseskode sendt til {mobile}",
	sms_otp_send_failed: "SMS ikke sendt. Kontakt administrator.",
	sms_otp_incorrect_code: "Ukorrekt eller utløpt kode",
	forgot: {
		back: "Tilbake",
		send_request: "Gjenopprett passord ",
		forgot_t: "Glemt passord",
		confirm_pass: "Bekreft passord",
		forgot: "Glemt passord?",
		invalidrequest_t: "Feil ved forespørsel",
		invalidrequest_m: "Ugyldig link.",
		reset_t: "Passord Reset",
		reset_pass: "Forny passord",
		reset_success_m: "Nytt passord er satt.",
		reset_error_m: "Kan ikke endre passord akkurat nå. Vennligst prøv igjen senere.",
		forgot_success_m: "Link for passordgjenoppretting er sendt til ",
		forgot_error_m: "Kan ikke sende akkurat nå. Vennligst prøv igjen senere.",
		unregistered: " er ikke registrert.",
		invalid_token: "Invalid password reset token.",
		invalid_email: "Ugyldig epostadresse",
		valid_token: "Nytt passord er sendt til  ({email})",
		expired_token: "Passord lenke utløpt",
	},
};
export default auth;